import React, { Component } from 'react';
import { Navigate } from 'react-router-dom';
import axios from 'axios';

class AuthGate extends Component {
    constructor() {
        super();
        this.state = { status: 'verifying' };
    }

    componentDidMount() {
        const token = localStorage.getItem('token');
        if (!token) {
            this.setState({ status: 'unauthorized' });
            return;
        }
        axios.post(
            process.env.REACT_APP_SERVER_API + '/auth/token-verification',
            {},
            { headers: { Authorization: 'Bearer ' + token } }
        ).then(() => {
            this.setState({ status: 'authorized' });
        }).catch(() => {
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            localStorage.removeItem('upcoming_event');
            this.setState({ status: 'unauthorized' });
        });
    }

    render() {
        if (this.state.status === 'unauthorized') {
            return <Navigate to="/signin" replace />;
        }
        if (this.state.status === 'verifying') {
            return (
                <div className="loading-screen">
                    <div className="loading-spinner"></div>
                </div>
            );
        }
        return this.props.children;
    }
}

export default AuthGate;
